import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { required } from "redux-form-validators";
import { renderField, renderTextField, renderselect } from "../../../Components/Forms/renders";
import { getCertificaten } from "../Reducers/actions";

const TemplateBasicInfo = (props) => {
  const { handleSubmit, pristine, submitting, onSubmit, initialValues } = props;
  const dispatch = useDispatch();
  const [certificaten, setCertificaten] = useState([]);
  const [loadingCertificaten, setLoadingCertificaten] = useState(true);

  useEffect(() => {
    loadCertificaten();
  }, []);

  const loadCertificaten = async () => {
    try {
      const response = await dispatch(getCertificaten());
      setCertificaten(response.results || []);
    } catch (error) {
      console.error("Error loading certificaten:", error);
    } finally {
      setLoadingCertificaten(false);
    }
  };

  const getCertificaatOptions = () => {
    const options = { "": "Geen certificaat" };
    certificaten.forEach(cert => {
      options[cert._id] = cert.name;
    });
    return options;
  };

  const handleNextStep = (e) => {
    e.preventDefault();
    // Get current form values
    const formValues = props.formValues || initialValues;
    // Stuur alleen de basis informatie velden, niet het hele template object
    const basicInfoFields = {
      name: formValues.name,
      description: formValues.description,
      category: formValues.category,
      certificaat: formValues.certificaat,
      version: formValues.version,
      is_default: formValues.is_default === 'true' || formValues.is_default === true,
      is_active: formValues.is_active === 'true' || formValues.is_active === true,
    };
    onSubmit(basicInfoFields);
  };

  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="box-body">
          <div className="row">
            <div className="col-md-8 offset-md-2">
              <h4>Basis Informatie Sjabloon</h4>
              <p className="text-muted">
                Vul eerst de basis informatie van het inspectie sjabloon in.
                In de volgende stap kun je de specifieke vragen/items toevoegen.
              </p>

              <Field
                name="name"
                type="input"
                validate={[required()]}
                component={renderField}
                label="Naam Sjabloon"
                placeholder="Bijv. Zwembad Veiligheidsinspectie 2025"
              />

              <Field
                name="description"
                type="input"
                component={renderTextField}
                label="Beschrijving"
                placeholder="Korte beschrijving van dit inspectie sjabloon..."
              />

              <Field
                name="category"
                type="input"
                validate={[required()]}
                component={renderselect}
                options={{
                  algemeen: "Algemeen",
                  veiligheid: "Veiligheid",
                  "hygiëne": "Hygiëne",
                  technisch: "Technisch",
                  legionella: "Legionella",
                  chemisch: "Chemisch"
                }}
                label="Categorie"
              />

              <Field
                name="certificaat"
                type="input"
                component={renderselect}
                options={getCertificaatOptions()}
                label="Certificaat (optioneel)"
                disabled={loadingCertificaten}
              />
              {certificaten.length === 0 && !loadingCertificaten && (
                <small className="text-muted d-block mb-3">
                  Nog geen certificaten aangemaakt. <a href="/zwembadinspecties/certificaten">Maak een certificaat aan</a>
                </small>
              )}

              <div className="row">
                <div className="col-md-6">
                  <Field
                    name="version"
                    type="input"
                    component={renderField}
                    label="Versie"
                    placeholder="1.0"
                  />
                </div>
                <div className="col-md-6">
                  <Field
                    name="is_default"
                    type="input"
                    component={renderselect}
                    options={{
                      false: "Nee",
                      true: "Ja"
                    }}
                    label="Standaard sjabloon"
                  />
                </div>
              </div>

              <Field
                name="is_active"
                type="input"
                component={renderselect}
                options={{
                  true: "Actief",
                  false: "Inactief"
                }}
                label="Status"
              />
            </div>
          </div>

          <div className="text-center mt-4">
            <button
              type="button"
              className="btn btn-primary btn-lg"
              disabled={submitting}
              onClick={handleNextStep}
            >
              Volgende Stap: Hoofdstukken <i className="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

let ReduxTemplateBasicInfo = reduxForm({
  form: "template_basic_info",
  enableReinitialize: true
})(TemplateBasicInfo);

ReduxTemplateBasicInfo = connect((state) => {
  const template = state.zwembadinspecties.inspectionTemplate;
  return {
    initialValues: template ? {
      ...template,
      certificaat: template.certificaat?._id || template.certificaat || ""
    } : {
      is_active: true,
      is_default: false,
      category: 'algemeen',
      version: '1.0',
      certificaat: ""
    },
    formValues: state.form?.template_basic_info?.values
  };
})(ReduxTemplateBasicInfo);

export default ReduxTemplateBasicInfo;
